// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3869":"WorldCupNostalgia","6609":"SporToto","7832":"Coupons","9148":"MatchCard","9549":"SportsBook"}[chunkId] + "." + {"3869":"dd30a7ba","6609":"ea19c7f9","7832":"ea19c7f9","9148":"ea19c7f9","9549":"ea19c7f9"}[chunkId] + ".css";
};